import { FC } from 'react'

export interface LocationProps {
  width?: number
  height?: number
  filled?: boolean
}

const Location: FC<LocationProps> = ({ width, height, filled = false }) => {
  if (filled) {
    return (
      <svg
        width={width || 7}
        height={height || 11}
        viewBox={'0 0 7 11'}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5 11C3.5 11 7 6.625 7 4C7 2.067 5.433 0.5 3.5 0.5C1.567 0.5 0 2.067 0 4C0 6.625 3.5 11 3.5 11ZM3.5 5.75C4.4665 5.75 5.25 4.9665 5.25 4C5.25 3.0335 4.4665 2.25 3.5 2.25C2.5335 2.25 1.75 3.0335 1.75 4C1.75 4.9665 2.5335 5.75 3.5 5.75Z"
          fill="currentColor"
        />
      </svg>
    )
  }
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 8C19.5 9.40191 19.0292 11.0796 18.2892 12.8372C17.5526 14.5867 16.5665 16.3754 15.5742 17.988C14.5827 19.5991 13.5904 21.0256 12.8456 22.0497C12.5028 22.5211 12.2128 22.9066 12 23.1851C11.7872 22.9066 11.4972 22.5211 11.1544 22.0497C10.4096 21.0256 9.41729 19.5991 8.42583 17.988C7.4335 16.3754 6.44742 14.5867 5.71082 12.8372C4.97076 11.0796 4.5 9.40191 4.5 8C4.5 3.85786 7.85786 0.5 12 0.5C16.1421 0.5 19.5 3.85786 19.5 8Z"
        stroke="currentColor"
      />
      <circle cx="12" cy="8" r="3.5" stroke="currentColor" />
    </svg>
  )
}

export default Location
